<template>
  <div class="card rounded-0">
    <div class="mx-4">
      <!-- HEADER -->
      <div class="group-rounded-box my-4">
        <!-- ROW -->
        <div class="row">
          <!-- MAIN COLUMN -->
          <div class="col-12 px-2">
            <!-- TABLE LAYOUT FOR LARGE SCREENS -->
            <div v-if="!$breakpoint.mdAndDown" class="table-container">
              <!-- TERMINAL, CUSTOMER, PAYMENT TERM, CREDIT -->
              <table class="table responsive-table table-borderless">
                <tbody>
                  <tr>
                    <th>Customer</th>
                    <td v-if="customer">{{ customer.name }}</td>
                    <td v-else>&mdash;</td>
                  </tr>
                  <tr>
                    <th>Terminal</th>
                    <td v-if="terminal">{{ terminal.name }}</td>
                    <td v-else>&mdash;</td>
                  </tr>
                  <tr class="spacing-above">
                    <th>Payment Term</th>
                    <td v-if="customer && customer.credit && customer.credit.days != null">
                      {{ customer.credit.days | creditdaysformat }}
                    </td>
                    <td v-else>&mdash;</td>
                  </tr>
                  <tr>
                    <th>Available Credit GBP</th>
                    <td v-if="customer && customer.credit && customer.credit.limit != null">
                      {{ customer.credit.limit | priceformat }}
                    </td>
                    <td v-else>&mdash;</td>
                  </tr>
                  <tr v-if="!isNetwork && !isContract">
                    <th>Lifting Period</th>
                    <td label="" v-if="!isContract" class="px-0">
                      <el-date-picker
                      class="order-capture-datepicker"
                        v-model="liftingPeriod"
                        :disabled="!basketHasItems"
                        :picker-options="pickerOptions"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="Start date"
                        end-placeholder="End date">
                      </el-date-picker>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- ORDERS -->
              <div
                v-for="(item, key) of basketItems"
                :key="key"
                class="group-rounded-box my-1"
                :class="showBasketError && !item.isOfferAvailable ? 'alert-danger' : 'bg-olf-light-greyish-blue'"
              >
                <table class="table responsive-table table-borderless">
                  <tbody>
                    <tr>
                      <td></td>
                      <td class="d-flex flex-row-reverse">
                        <button @click="$emit('remove-item', key)" class="btn p-0">
                          <i class="fas fa-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                    <tr v-if="isNetwork">
                      <th>Network</th>
                      <td>
                        {{ item.networkId | networksname }}
                      </td>
                    </tr>
                    <tr>
                      <th>Product</th>
                      <td>{{ item.fuel_id | fueltype }}</td>
                    </tr>
                    <tr>
                      <th>Volume</th>
                      <td>
                        <cleave
                          :value="item.quantity"
                          :options="numeralPositive"
                          class="cleave-input"
                          :class="{'border-danger': !isQuantityValid(item)}"
                          @input="onVolumeChange($event, key)"
                        />
                      </td>
                    </tr>
                    <tr v-if="!isQuantityValid(item)">
                      <td></td>
                      <td>
                        <span
                          class="error-message"
                          >{{ invalidQuantityErrorMessage(item) }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <th>Price ppl</th>
                      <td>{{ item.quotePrice | priceformat }}</td>
                    </tr>
                    <tr v-if="!isNetwork">
                      <th>Lifting Period</th>
                      <td v-if="liftingPeriod && liftingPeriod.length > 0">{{ {liftingPeriod} | liftingperiodformat }}</td>
                      <td v-else>{{ item | liftingperiodformat }}</td>
                    </tr>
                    <tr v-if="isNetwork && !isContract">
                      <th>Account No.</th>
                      <td label="Account No.">
                        <input
                          class="form-control white-field"
                          :style="isBunkeringAccountNoEmpty[key] ? 'border-color:red' : ''"
                          v-model="item.reference"
                          placeholder="Enter Account..."
                          @keypress="isNumberKeyEvent($event)"
                        />
                        <span v-if="isBunkeringAccountNoEmpty[key]" class="error-message"
                          >Please enter an account number</span
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <table v-if="!isContract" class="table responsive-table table-borderless">
                <tbody>
                  <!-- DELIVERED IN -->
                  <tr class="spacing-above">
                    <th>
                      <label class="float-left mr-3"> Delivered In </label>
                      <input type="checkbox" v-model="isDeliveredIn" :disabled="!basketHasItems || isNetwork">
                    </th>
                  </tr>
                  <tr :style=" !isDeliveredIn ? 'opacity: 0.4': ''" :class="{ 'error-message': haulageRateError }">
                    <th> Haulage PPL </th>
                    <td class="px-0">
                      <cleave
                        style="width: 100%;"
                        v-model="haulageRate"
                        :options="numeralPositive"
                        :disabled="!isDeliveredIn"
                        placeholder="Enter Haulage Rate"
                        :class="{ 'element-error' : haulageRateError }"
                      />
                    </td>
                  </tr>
                  <tr v-if="haulageRateError">
                    <td></td>
                    <td>
                      <span class="error-message">
                        Haulage rate must be above zero
                      </span>
                    </td>
                  </tr>
                  <tr :style=" !isDeliveredIn ? 'opacity: 0.4': ''" :class="{ 'error-message': deliveryLocationsError }">
                    <th> Delivery Location </th>
                    <td class="px-0">
                      <el-select
                        v-model="selectedDeliveryLocation"
                        value-key="_id"
                        placeholder="Search delivery location"
                        clearable
                        filterable
                        :disabled="!isDeliveredIn"
                        :class="{ 'element-error' : deliveryLocationsError }"
                      >
                        <el-option
                          v-for="location in deliveryLocations"
                          :key="location._id"
                          :label="location.name"
                          :value="location"
                        >
                        </el-option>
                        <template #empty>No location found</template>
                      </el-select>
                    </td>
                  </tr>
                  <tr :style="!isDeliveredIn ? 'opacity: 0.4': ''" :class="{ 'error-message': deliveryDateError }">
                    <th> Delivery Date </th>
                    <td class="px-0">
                    <el-date-picker
                      class="w-100"
                      v-model="deliveryDate"
                      type="date"
                      :picker-options="pickerOptions"
                      :disabled="!isDeliveredIn"
                      :class="{ 'element-error' : deliveryDateError }"
                    >
                    </el-date-picker>
                    </td>
                  </tr>
                  <!--ORDER REFERENCE-->
                  <tr class="spacing-above">
                    <th>Order Reference (Optional)</th>
                    <td class="px-0">
                      <input
                        placeholder="Enter Order Ref."
                        class="form-control white-field bg-olf-light-greyish-blue"
                        v-model="orderReference"
                      />
                    </td>
                  </tr>
                  <tr v-if="brands.length > 0" :class="{ 'error-message': brandRequiredError }">
                    <th>Credit Line (Required)</th>
                    <td class="px-0">
                      <el-select
                        v-model="selectedBrand"
                        value-key="_id"
                        placeholder="Select Brand"
                        filterable
                        :class="{ 'element-error' : brandRequiredError }"
                      >
                        <el-option v-for="item in brands" :key="item._id" :label="item.name" :value="item"></el-option>
                        <!-- User search resulting in no match -->
                        <template #empty>No brands found</template>
                      </el-select>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="mb-0 table responsive-table table-borderless">
                <tbody>
                  <tr>
                    <td class="text-justify">
                      <span :class="{ 'error-message': showTickboxError }">
                        Please tick to confirm all the information in this order is correct. </span
                      >.
                    </td>
                    <td>
                      <input
                        class="float-right ml-2 mr-0"
                        :style="showTickboxError ? 'border-color:red' : ''"
                        type="checkbox"
                        :disabled="!basketHasItems"
                        v-model="confirmCheckbox"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="mb-0 table responsive-table table-borderless">
                <tbody>
                  <tr>
                    <th>Total cost ex VAT:</th>
                    <td>£ {{ totalCost | priceformat }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- TABLE LAYOUT FOR MEDIUM AND SMALL SCREENS -->
            <div v-else>
              <table class="table responsive-table table-borderless">
                <tbody>
                  <!-- TERMINAL, CUSTOMER, PAYMENT TERM, CREDIT -->
                  <tr>
                    <td label="Customer">
                      <span v-if="customer"> {{ customer.name }} </span>
                      <span v-else> &mdash; </span>
                    </td>
                    <td label="Terminal">
                      <span v-if="terminal"> {{ terminal.name }} </span>
                      <span v-else> &mdash; </span>
                    </td>
                    <td label="Payment Term">
                      <span v-if="customer && customer.credit && customer.credit.days != null">
                        {{ customer.credit.days | creditdaysformat }}
                      </span>
                      <span v-else> &mdash; </span>
                    </td>
                    <td label="Available Credit GBP">
                      <span v-if="customer && customer.credit && customer.credit.limit != null">
                        {{ customer.credit.limit | priceformat }}
                      </span>
                      <span v-else> &mdash; </span>
                    </td>
                    <td label="Lifting Period" v-if="!isNetwork && !isContract">
                      <el-date-picker
                        v-model="liftingPeriod"
                        :disabled="!basketHasItems"
                        :picker-options="pickerOptions"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="Start date"
                        end-placeholder="End date">
                      </el-date-picker>
                    </td>
                  </tr>
                  <!-- ORDERS -->
                  <tr v-for="(item, key) of basketItems" :key="key" :class="showBasketError && !item.isOfferAvailable ? 'alert-danger' : ''">
                    <td>
                      <span>
                        <button @click="$emit('remove-item', key)" class="btn p-0">
                          <i class="fas fa-trash-alt"></i>
                        </button>
                      </span>
                    </td>
                    <td v-if="isNetwork" label="Network">
                      {{ item.networkId | networksname }}
                    </td>
                    <td label="Product">
                      <span> {{ item.fuel_id | fueltype }} </span>
                    </td>
                    <td label="Volume">
                        <cleave
                          :value="item.quantity"
                          :options="numeralPositive"
                          style="width: 100%;"
                          :class="{'border-danger': !isQuantityValid(item)}"
                          @input="onVolumeChange($event, key)"
                        />
                    </td>
                    <td v-if="!isQuantityValid(item)">
                          <span class="error-message"
                          >{{ invalidQuantityErrorMessage(item) }}</span
                        >
                    </td>
                    <td label="Price ppl">
                      <span> {{ item.quotePrice | priceformat }} </span>
                    </td>
                    <td v-if="!isNetwork" label="Lifting Period">
                      <span v-if="liftingPeriod && liftingPeriod.length > 0"> {{ {liftingPeriod} | liftingperiodformat }} </span>
                      <span v-else> {{ item | liftingperiodformat }} </span>
                    </td>
                    <td v-if="isNetwork && !isContract" label="Account No.">
                      <input
                        class="form-control white-field bg-olf-light-greyish-blue"
                        :style="isBunkeringAccountNoEmpty[key] ? 'border-color:red' : ''"
                        v-model="item.reference"
                        placeholder="Enter Account..."
                        @keypress="isNumberKeyEvent($event)"
                      />
                    </td>
                    <td v-if="isBunkeringAccountNoEmpty[key]" class="error-message">Please enter an account number</td>
                  </tr>
                  <tr>
                    <!--DELIVERED IN-->
                    <td label="Delivered In">
                      <input
                        type="checkbox"
                        v-model="isDeliveredIn"
                        :disabled="!basketHasItems || isNetwork"
                      >
                    </td>
                    <td label="Haulage PPL" :style=" !isDeliveredIn ? 'opacity: 0.4': ''" :class="{ 'error-message': haulageRateError }">
                      <cleave
                        style="width: 100%;"
                        :value="haulageRate"
                        :options="numeralPositive"
                        :disabled="!isDeliveredIn"
                        placeholder="Enter Haulage Rate"
                        :class="{ 'element-error' : haulageRateError }"
                      />
                    </td>
                    <td v-if="haulageRateError">
                      <span class="error-message">
                        Haulage rate must be above zero
                      </span>
                    </td>
                    <td label="Delivery Locations" :style=" !isDeliveredIn ? 'opacity: 0.4': ''" :class="{ 'error-message': deliveryLocationsError }">
                      <el-select
                        v-model="selectedDeliveryLocation"
                        value-key="_id"
                        placeholder="Search delivery location"
                        clearable
                        filterable
                        :disabled="!isDeliveredIn"
                        :class="{ 'element-error' : deliveryLocationsError }"
                        class="w-100"
                      >
                        <el-option
                          v-for="location in deliveryLocations"
                          :key="location._id"
                          :label="location.name"
                          :value="location"
                        >
                        </el-option>
                        <template #empty>No location found</template>
                      </el-select>
                    </td>
                    <td label="Delivery Date" :style=" !isDeliveredIn ? 'opacity: 0.4': ''" :class="{ 'error-message': deliveryDateError }">
                      <el-date-picker
                        v-model="deliveryDate"
                        type="date"
                        :picker-options="pickerOptions"
                        class="el-datepicker-correction w-100"
                        :disabled="!isDeliveredIn"
                        :class="{ 'element-error' : deliveryDateError }"
                      >
                      </el-date-picker>                     
                    </td>
                    <!--ORDER REFERENCE-->
                    <td
                      v-if="!isContract"
                      label="Order Ref."
                    >
                      <input
                        placeholder="Enter Order Ref."
                        class="form-control white-field bg-olf-light-greyish-blue"
                        v-model="orderReference"
                      />
                    </td>
                    <td label="Total Cost ex VAT">
                      <span> £ {{ totalCost | priceformat }} </span>
                    </td>
                    <td class="md-default-before-override pt-3">
                      <span class="text-justify" :class="{ 'error-message': showTickboxError }"
                        >Please tick to confirm all the information in this order is correct.
                      </span>
                      <input
                        class="ml-2 mr-0"
                        :style="showTickboxError ? 'border-color:red' : ''"
                        type="checkbox"
                        :disabled="!basketHasItems"
                        v-model="confirmCheckbox"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!--BASKET COUNTDOWN-->
          <div v-if="basketHasItems" class="col-12">
            <div class="basket-countdown my-3">
              <radial-progress-bar
                class="countdown-progress prices-lock"
                :diameter="$breakpoint.smAndDown ? 55 : 50"
                :totalSteps="basketTimeLimit"
                :completedSteps="refreshBasketCountdown"
                :class="countdownColour"
              />
              <i class="fas fa-lock" :class="countdownColour"></i>
              <span :class="{ 'mx-2': $breakpoint.mdAndDown }" class="countdown-message"
                >These prices are locked for the next
                {{ refreshBasketCountdown | countdownfullformat }}
              </span>
            </div>
          </div>
          <!--ERROR MESSAGE -->
          <div v-if="basketErrorMessage != null" class="col-12 alert alert-danger mt-3 text-center">
            <i class="fas fa-info-circle mr-2"></i> {{ basketErrorMessage }}
          </div>
          <!--CLEAR/REFRESH/PLACE ORDER -->
          <div class="col-12 d-flex justify-content-between">
            <button
              class="m-1"
              :class="{
                'btn btn-tertiary': !basketHasItems,
                'btn btn-secondary': basketHasItems && refreshBasketCountdown >= 1,
                'btn btn-primary': basketHasItems && refreshBasketCountdown < 1,
              }"
              :disabled="!basketHasItems"
              @click="$emit('refresh-offers', $event)"
            >
              Refresh Basket
            </button>
            <button
              v-if="!isPriceQuote"
              class="m-1"
              :class="basketHasItems ? 'btn btn-secondary' : 'btn btn-tertiary'"
              :disabled="!basketHasItems || !allQuantitiesAboveZero"
              @click="savePriceQuote"
            >
              Save Price Quote
            </button>
            <button
              class="m-1"
              :class="{
                'btn btn-tertiary': placeOrderButtonDisabled,
                'btn btn-primary': !placeOrderButtonDisabled,
              }"
              :disabled="placeOrderButtonDisabled"
              @click="placeOrder"
            >
              Place Order
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment';

import breakpoint from "@/mixins/index";

import { isNumberKeyEvent } from "@/util/util";
import { eBasketErrorMessages } from "@/util/enums/basket";
import { volumeFormat } from "@/util/filters";

import { getLocations } from "@/api/metadata";

function initialDataState() {
  return {
    orderReference: null,
    selectedBrand: null,
    confirmCheckbox: false,
    tickboxCheckedOnce: false,
    showBasketError: true,
    isNumberKeyEvent,
    liftingPeriod: [],
    pickerOptions: {
      disabledDate(time) {
        return time.getTime() < moment().startOf('day');
      },
    },
    isDeliveredIn: false,
    deliveryLocations: [],
    haulageRate: null,
    selectedDeliveryLocation: null,
    deliveryDate: null,
  };
}

export default {
  data() {
    return initialDataState();
  },
  props: {
    basketItems: {
      type: Array,
    },
    customer: {
      type: Object,
    },
    terminal: {
      type: Object,
    },
    brands: {
      type: Array,
      default: () => []
    },
    basketTimeLimit: {
      type: Number,
      required: true,
    },
    refreshBasketCountdown: {
      type: Number,
      required: true,
    },
    isPriceQuote: {
      type: Boolean,
      required: true,
    },
    basket: {
      type: Object,
      required: false
    },
    triggerBasketErrorDisplay: {
      type: Number,
      default: 0
    },
    parentErrorMessage: {
      type: String,
      required: false,
    },
  },
  mixins: [breakpoint],
  computed: {
     ...mapGetters("inputCheckers", ["numeralPositive"]),
    ...mapGetters("orderCapture", ["isContract"]),
    ...mapGetters("metadata", ["networks"]),
    totalCost: function() {
      const totalProductCost = this.basketItems.reduce((acc, { totalPrice }) => acc + totalPrice, 0);
      return totalProductCost + this.totalHaulageCost; 
    },
    totalHaulageCost: function() {
      if (this.isDeliveredIn && this.haulageRate != null) {
        const totalQuantity = this.basketItems.reduce((acc, { quantity }) => acc + Number(quantity), 0);
        return Number((totalQuantity * Number(this.haulageRate) / 100).toFixed(2));
      }
      return 0;
    },
    basketHasItems: {
      get: function() {
        return this.basketItems.length > 0;
      },
    },
    brandRequiredError: {
      get: function() {
        return this.confirmCheckbox && this.brands.length > 0 && this.selectedBrand === null && !this.isContract;
      },
    },
    haulageRateError: function() {
      return this.confirmCheckbox && this.isDeliveredIn && Number(this.haulageRate) <= 0;
    },
    deliveryLocationsError: function() {
      return this.confirmCheckbox && this.isDeliveredIn && !this.selectedDeliveryLocation;
    },
    deliveryDateError: function() {
      return this.confirmCheckbox && this.isDeliveredIn && !this.deliveryDate;
    },
    isNetwork: function() {
      return this.basketItems.length > 0 && this.basketItems[0].networkId != null;
    },
    placeOrderButtonDisabled: {
      get: function() {
        return (
          !this.basketHasItems ||
          !this.confirmCheckbox ||
          this.isBunkeringAccountNoEmpty.some((isEmpty) => isEmpty) ||
          this.refreshBasketCountdown < 1 ||
          this.errorMessage != null ||
          this.brandRequiredError ||
          this.haulageRateError ||
          this.deliveryLocationsError ||
          this.deliveryDateError
        );
      },
    },
    showTickboxError: function() {
      return this.tickboxCheckedOnce && !this.confirmCheckbox;
    },
    isBunkeringAccountNoEmpty: function() {
      if (this.isNetwork & !this.isContract) {
        return this.basketItems.map((basketItem) => this.tickboxCheckedOnce && !basketItem.reference);
      }
      return [];
    },
    allQuantitiesValid: function() {
      return this.basketItems.every(item => this.isQuantityValid(item));
    },
    allQuantitiesAboveZero: function() {
      return this.basketItems.every(({quantity}) => Number(quantity) > 0);
    },
    countdownColour: function() {
      if (this.refreshBasketCountdown < 30) {
        return "red";
      } else if (this.refreshBasketCountdown < 60) {
        return "amber";
      }
      return "green";
    },
    areAllBasketItemsAvailable: function() {
      return this.basketItems.every(({ isOfferAvailable }) => isOfferAvailable);
    },
    triggerCreditLimitError: function () {
      return this.customer && this.customer.credit.limit < this.totalCost;
    },
    basketErrorMessage: function () {
      if (this.showBasketError) {
        if (!this.areAllBasketItemsAvailable) {
          return eBasketErrorMessages.OfferUnavailableError;
        }
        if (!this.allQuantitiesAboveZero) {
          return eBasketErrorMessages.ZeroOrNullVolumeError;
        }
        if (!this.allQuantitiesValid) {
          return eBasketErrorMessages.InvalidVolumeError;
        }
        if (this.triggerCreditLimitError) {
          return eBasketErrorMessages.CreditLimitError;
        }
        if (this.parentErrorMessage) {
          return this.parentErrorMessage;
        }
      }
      return null;
    },
    isCustomerAndDeliveredIn: function() {
      return this.customer && this.isDeliveredIn;
    }
  },
  watch: {
    "basket.brand":{
      handler: function (brand) {
        if (this.brands && brand && brand.brandReferenceId) {
          this.selectedBrand = this.brands.find(b => brand.brandReferenceId ===  b.brandReferenceId);
        }
      }
    },
    "basket.customLiftingPeriod":{
      handler: function (customLiftingPeriod) {
        if (this.liftingPeriod && customLiftingPeriod && customLiftingPeriod.length === 2) {
          this.liftingPeriod = [new Date(customLiftingPeriod[0]), new Date(customLiftingPeriod[1])];
        }
      }
    },
    "basket.orderReference":{
      handler: function (orderReference) {
        if (this.orderReference !== undefined && orderReference) {
          this.orderReference = orderReference;
        }
      }
    },
    "basket.deliveredInData":{
      handler: async function (deliveredInData) {
        if(deliveredInData) {
          const { 
            deliveryDate,
            haulageRate, 
            location_id 
          } = deliveredInData;

          if(location_id || haulageRate || deliveryDate) {
            this.isDeliveredIn = true;
            if (deliveryDate) {
              this.deliveryDate = new Date(deliveryDate);
            }
            if (haulageRate) {
              this.haulageRate = haulageRate;
            }
            if (location_id) {
              this.deliveryLocations = await this.getDeliveryLocations(this.customer.id)
              const location = this.deliveryLocations.find(({_id}) => _id === location_id);
              if (location) {
                this.selectedDeliveryLocation = location;
              }
            }
          }
        }
      }
    },
    isCustomerAndDeliveredIn: async function() {
      if (this.isCustomerAndDeliveredIn) {
        this.deliveryLocations = await this.getDeliveryLocations(this.customer.id);
      } else {
        this.deliveryLocations = [];
      }
    },
    basketItems: function () {
      if (this.basketItems.length === 0) {
        this.resetComponentData();
      }
    },
    confirmCheckbox: function () {
      if (this.confirmCheckbox) {
        this.tickboxCheckedOnce = true;
        this.showBasketError = false;
      } else {
        this.showBasketError = true;
      }
    },
    basketErrorMessage: function () {
      if (this.basketErrorMessage != null) {
        this.confirmCheckbox = false;
      }
    },
    triggerBasketErrorDisplay: function() {
      this.showBasketError = true;
    }
  },
  methods: {
    getDeliveryLocations: async function(buyerAccountId) {
      const { data } = await getLocations(buyerAccountId);
      return data.locations;
    },
    resetComponentData: function() {
      Object.assign(this.$data, initialDataState());
    },
    placeOrder: async function () {
      if(this.liftingPeriod.length > 0){
        this.liftingPeriod[0] = `${moment(this.liftingPeriod[0]).format("YYYY-MM-DD")}T12:00:00.000000Z`;
        this.liftingPeriod[1] = `${moment(this.liftingPeriod[1]).format("YYYY-MM-DD")}T12:00:00.000000Z`;
      }
      let deliveredInData = null;
      if (this.isDeliveredIn) {
        deliveredInData = {
          location_id: this.selectedDeliveryLocation._id,
          deliveryDate: this.deliveryDate,
          haulageRate: this.haulageRate,
        }
      }
      this.$emit("place-order", this.orderReference, this.liftingPeriod, this.selectedBrand, deliveredInData);
    },
    savePriceQuote() {
      let deliveredInData = null;
      if (this.isDeliveredIn) {
        deliveredInData = {
          location_id: this.selectedDeliveryLocation._id,
          deliveryDate: this.deliveryDate,
          haulageRate: this.haulageRate,
        }
      }
      this.$emit('save-price-quote', this.orderReference, this.liftingPeriod, this.selectedBrand, deliveredInData)
    },
    onVolumeChange: function(newVol, itemIdx) {
      this.$emit('update-volume', newVol, itemIdx);
    },
    isQuantityValid(item) {
      if (item.quantity == null || item.quantity === "") {
        return false;
      }
      return item.quantity >= item.minimumOrderQuantity && item.currentMaximumAvailable >= 0
    },
    invalidQuantityErrorMessage(item) {
      if (item.currentMaximumAvailable < 0 ) {
        return `Max Available Vol: ${volumeFormat(item.maximumAvailable)} L`;
      } else {
        return `Minimum Vol: ${volumeFormat(item.minimumOrderQuantity)} L`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/_basket-countdown.scss";
@import "@/assets/scss/components/_element.scss";

.cleave-input {
  width: 100%;
  background: map-get($theme-colors, olf-white);
  text-align: right;
}
.mw-200 {
  max-width: 200px;
}

tr.spacing-above > td {
  padding-top: 1em;
}

tr.spacing-above > th {
  padding-top: 1em;
}

td {
  text-align: right;
}

td.md-default-before-override {
  &:before {
    content: none !important;
  }
}

.sm-danger {
  background-color: #f2dede;
  border-color: #ebccd1;
}

.order-capture-datepicker{
  width: 100% !important;
}

::v-deep .el-icon-date {
    display: flex;
    &:before {
      display: flex;
      align-items: center;
    }
}

::v-deep .el-icon-circle-close {
  display: flex;
  align-items: center;
}

::v-deep .el-datepicker-correction {
  .el-input__suffix {
    display: inline-flex !important;
    width: 10% !important;
    right: 5px;
  }
  .el-input__prefix {
    width: 10% !important;
    left: 5px;
  }
}

::v-deep .el-input__inner {
  font-size: 13px !important;
  &::placeholder {
    color: map-get($theme-colors, tertiary) !important;
    font-size: 13px;
  }
}
</style>
